import React from "react";
import { img_path } from "../../../environment";

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
}

const ImageWithBasePath = (props: Image) => {
  // Combine the base path and the provided src to create the full image source URL
  var fullSrc;
  if (props?.src == null || props?.src == "null" || props?.src == "") {
    fullSrc=`/assets/img/users/user.png`
  } else {
    fullSrc = props?.src?.startsWith("http") 
      ? props.src
      : `${img_path}${props.src}`;
  }
  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
    />
  );
};

export default ImageWithBasePath;
